module.exports = __webpack_public_path__ + "static/media/smile_face.8f377416.png";